module.exports = __webpack_public_path__ + "media/images/weather/117_day-601b0866872d4965328f309c5524d901.png";